import { xget, xhttp } from "../Fetchv2.js";
import { PGSchema } from "../schemas/pg.schema.js";

export class Medicalv2API {
	/**
	 * @path /pages/:pgid/medical
	 * @param pgid - Page ID
	 * @param token - Token
	 * @param query - Query parameters (take, skip, job_id, uid)
	 */
	async getAllUsersMedical(pgid: string, token: string, query?: { take?: number; skip?: number; job_id?: string; uid?: string }) {
		return xget<{
			results: PGSchema.users_medical[];
			positions: PGSchema.jobs[];
			users: PGSchema.users[];
		}>(`/pages/${pgid}/medical`, query || {}, {
			headers: { "app-token": token }
		});
	}

	async getMedical(pgid: string, medicalId: string) {
		return xget<{ medical: PGSchema.users_medical; position: PGSchema.jobs; user: PGSchema.users }>(`/pages/${pgid}/medical/${medicalId}`, {}, { headers: {} });
	}

	/**
	 * @path /pages/:pgid/medical
	 * @param pgid - Page ID
	 * @param data - Users Medical data (must include pgid and job_id)
	 * @param token - Token
	 */
	async createUsersMedical(pgid: string, data: Partial<PGSchema.users_medical>, token: string) {
		return xhttp<{
			medical: PGSchema.users_medical;
			user: PGSchema.users;
			position: PGSchema.jobs;
		}>(`/pages/${pgid}/medical`, "POST", data, {
			headers: { "app-token": token }
		});
	}

	/**
	 * @path /pages/:pgid/medical/:medical_id/link
	 * @param pgid - Page ID (used as job_id in backend)
	 * @param medicalId - Medical ID
	 * @param url - URL to link
	 */
	async updateMedicalLink(pgid: string, medicalId: string, url: string) {
		return xhttp<PGSchema.users_medical>(`/pages/${pgid}/medical/${medicalId}/link`, "POST", { url }, {});
	}

	/**
	 * @path /pages/:pgid/medical/:tid
	 * @param pgid - Page ID (used as job_id in backend)
	 * @param tid - Medical ID to delete
	 * @param token - Token
	 */
	async deleteUsersMedical(pgid: string, tid: string, token: string) {
		return xhttp<{ ok: boolean; message: string }>(
			`/pages/${pgid}/medical/${tid}`,
			"DELETE",
			{},
			{
				headers: { "app-token": token }
			}
		);
	}
}
